import { Field, NumericInput, TextOutput } from '../../../../Core';
import { FieldSet } from '../../../../Layout';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { useSelector } from 'react-redux';
import { IWorksheetComponent } from '../../../Core/types';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import deepEquals from 'Lib/Object/deepEquals';
import { hasEmptyValue, hasNonEmptyValue, hasValue } from 'Lib/Any';
import { LoadCellItem } from '../../types';

let EquipmentLoadCellFieldSetBase: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const loadCell = useSelector(createWorksheetSelector!('LoadCell'), deepEquals) as LoadCellItem;
  const loadCellFactor = useSelector(createWorksheetSelector!('LoadCell.Results.LoadCellFactor'), deepEquals);
  const loadCellMismatch = useSelector(createWorksheetSelector!('LoadCell.Mismatch')) as boolean;
  const loadCellCalibrationMismatch = useSelector(createWorksheetSelector!(`LoadCell.CalibrationMismatch`)) as boolean;
  const loadCellReadability = useSelector(createWorksheetSelector!(`LoadCell.Results.Readability`));

  return (
    <FieldSet>
      <Field
        input={<WorksheetEquipmentDropdown />}
        equipmentType="load-cell"
        name="LoadCell"
        importedCalibration={{
          Mismatch: loadCellCalibrationMismatch,
          LoadCellFactor: loadCellFactor,
        }}
        importedAdditionalData={{
          Mismatch: loadCellMismatch,
          Readability: loadCellReadability,
        }}
        importModel={{ Id: loadCell?.Id }}
      />
      <Field input={<TextOutput />} name="LoadCell.Results.Readability" visible={hasValue(loadCellReadability)} />
      <Field
        input={<TextOutput />}
        name="LoadCell.Results.LoadCellFactor"
        visible={hasNonEmptyValue(loadCell?.LoadCellFactor)}
      />
      <Field input={<NumericInput />} name="LoadCellFactor" visible={hasEmptyValue(loadCell?.LoadCellFactor)} />
    </FieldSet>
  );
};

const EquipmentLoadCellFieldSet = withInjectedProps(EquipmentLoadCellFieldSetBase);
export { EquipmentLoadCellFieldSet };
export default EquipmentLoadCellFieldSet;
